import { ButtonAttributes } from '../interfaces/ButtonAttributes'

export const generateButtonStyles = ({
  alignment,
  variant,
  borderRadius,
  buttonColor,
  textColor,
}: Partial<ButtonAttributes>): string => {
  const styles: string[] = [
    'position: relative',
    'margin-top: 1rem',
    'margin-bottom: 1rem',
    'padding: 0.375rem 0.75rem',
    'display: block',
    'text-align: center',
    'text-decoration: none',
    'text-transform: uppercase',
    'font-weight: 700',
  ]
  switch (alignment) {
    case 'left':
      styles.push('margin-right:auto')
      styles.push('margin-left:0')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    case 'center':
      styles.push('margin-right:auto')
      styles.push('margin-left:auto')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    case 'right':
      styles.push('margin-right:0')
      styles.push('margin-left:auto')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    default:
      styles.push('margin-right:auto')
      styles.push('margin-left:0')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')

      break
  }
  switch (variant) {
    case 'outline':
      styles.push(`background-color: transparent`)
      styles.push(`color: ${textColor}`)
      styles.push(`border: 1px solid ${buttonColor}`)
      break
    case 'filled':
    default:
      styles.push(`background-color: ${buttonColor}`)
      styles.push(`color: ${textColor}`)
      styles.push('border: none')
      break
  }
  switch (borderRadius) {
    case 'sharp':
      styles.push('border-radius: 0')
      break
    case 'smooth':
      styles.push('border-radius: 0.25rem')
      break
    case 'round':
    default:
      styles.push('border-radius: 2rem')
      break
  }
  return styles.join(';')
}
